export default {
    'sort-by-most-visited': 'Sort by most visited',
    'sort-by-least-visits': 'Sort by least visits'
}